import { render, staticRenderFns } from "./SuperficieCorporal.vue?vue&type=template&id=5c6d49a4"
import script from "./SuperficieCorporal.vue?vue&type=script&lang=js"
export * from "./SuperficieCorporal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports